/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropwinnerssend2Inputs */

const en_dropwinnerssend2 = /** @type {(inputs: Dropwinnerssend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send to winners`)
};

const de_dropwinnerssend2 = /** @type {(inputs: Dropwinnerssend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An Gewinner senden`)
};

/**
* | output |
* | --- |
* | "Send to winners" |
*
* @param {Dropwinnerssend2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropwinnerssend2 = /** @type {((inputs?: Dropwinnerssend2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropwinnerssend2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropwinnerssend2(inputs)
	return de_dropwinnerssend2(inputs)
});
export { dropwinnerssend2 as "dropWinnersSend" }